module.exports = __webpack_public_path__ + "static/media/helengeli-16.060b89f3.jpg";